import { MAX_MOBILE_WIDTH, isMobileDevice } from './isMobileDevice';

export type EnvironmentGuideVariant = 'mobile' | 'narrowScreen';

/** 모의면접 시작 전 환경 체크: 모바일이거나, PC라도 화면이 좁으면 안내가 필요하다. */
export const getEnvironmentGuideVariant = (): EnvironmentGuideVariant | null => {
  if (isMobileDevice()) {
    return 'mobile';
  }

  if (window.innerWidth < MAX_MOBILE_WIDTH) {
    return 'narrowScreen';
  }

  return null;
};
